import { SITTER_PROFILE_PREFIX } from './app';

type PageLayoutConfig = {
  [key: string]: {
    footer: string[];
    header: string[];
  };
};

export const HOME_PAGE_SLUG = '/';
export const HOW_IT_WORKS_PAGE_SLUG = '/how-it-works';
export const SEARCH_RESULTS_PAGE_SLUG = '/[serviceSlug]/[locationSlug]';
export const STEPPER_SLUG = '/stepper/[stepperId]';
export const PETS_PAGE_SLUG = '/pets';
export const PET_PROFILE_VIEW_PAGE_SLUG = '/pets/[petId]/view';
export const SERVICES_AND_RATES_PAGE_SLUG = '/profile/services-and-rates';
export const SERVICE_SETTINGS_PAGE_SLUG = '/profile/[serviceSlug]';
export const SHARED_SERVICE_SETTINGS_PAGE_SLUG = '/profile/shared-service-settings';
export const NOT_FOUND_PAGE_SLUG = '/404';
export const SERVICE_LANDING_PAGE_SLUG = '/pet-sitters/[servicePageId]';
export const SITTER_PROFILE_PAGE_SLUG = `/${SITTER_PROFILE_PREFIX}/[locationSlug]/[sitterProfileSlug]`;
export const BOOKING_ENQUIRY_PAGE_SLUG = `/${SITTER_PROFILE_PREFIX}/[locationSlug]/[sitterProfileSlug]/booking-enquiry`;
export const ACCOUNT_PAGE_SLUG = '/account';
export const ACCOUNT_BETA_PAGE_SLUG = '/account-beta';
export const ACCOUNT_SETTINGS_PAGE_SLUG = '/account-settings';
export const PERSONAL_DETAILS_PAGE_SLUG = '/account/personal-details';
export const NOTIFICATION_SETTINGS_PAGE_SLUG = '/account/settings';
export const MAD_PAWS_CREDITS_PAGE_SLUG = '/account/mad-paws-credits';
export const MESSAGES_PAGE_SLUG = '/inbox';
export const CHAT_PAGE_SLUG = '/inbox/[conversationId]/chat';
// Only the layout key of the test route; nothing links to it.
export const CHAT_BETA_PAGE_SLUG = '/inbox-beta/[conversationId]/chat';
export const BOOKINGS_PAGE_SLUG = '/bookings';
export const BOOKING_PAGE_SLUG = '/booking/[bookingId]';
export const BOOKINGS_BETA_PAGE_SLUG = '/bookings-beta';
export const BOOKING_BETA_PAGE_SLUG = '/booking-beta/[bookingId]';
export const BOOKINGS_BETA_DETAIL_PAGE_SLUG = '/bookings-beta/[bookingId]';
export const CALENDAR_PAGE_SLUG = '/calendar';
export const PAYMENT_PAGE_SLUG = '/billing-history';
export const PROFILE_PAGE_SLUG = '/profile';
export const PROFILE_ABOUT_PAGE_URL = '/profile/about';
export const PHOTO_GALLERY_PAGE_SLUG = '/profile/photo-gallery';
export const PHOTOS_PAGE_SLUG = '/photos';
export const HOUSEHOLD_PAGE_SLUG = '/profile/household';
export const REFERRAL_LANDING_PAGE_SLUG = '/refer-a-friend';
export const FAVOURITES_SLUG = '/favourites';
export const PASSWORD_RECOVERY_PAGE_SLUG = '/password-recovery';
export const PASSWORD_RESET_PAGE_SLUG = '/password-reset/[email]/[token]';
export const VERIFICATION_PAGE_SLUG = '/[serviceSlug]/verify/[token]';
export const SIGN_IN_PAGE_SLUG = '/sign-in';
export const SITTER_REGISTRATION_PAGE_SLUG = '/sitter/register';
export const CONTACT_MORE_PAGE_SLUG = `/${SITTER_PROFILE_PREFIX}/[locationSlug]/[sitterProfileSlug]/contact-more`;
export const BOOKING_CONFIRMATION_PAGE_SLUG = `/${SITTER_PROFILE_PREFIX}/[locationSlug]/[sitterProfileSlug]/booking-confirmation`;
export const BOOKING_PAYMENT_PAGE_SLUG = `/booking/[bookingId]/payment`;
export const BOOKING_RWB_REVIEW_PAGE_SLUG = `/booking/[bookingId]/rwb-review`;
export const PEAK_BOOKING_AVAILABILITY_PAGE_SLUG = '/peak-booking-availability';
export const REDEEM_BALANCE_PAGE_SLUG = '/redeem-balance';
export const TESTIMONIALS_PAGE_SLUG = '/testimonials';
export const WRITE_TESTIMONIALS_PAGE_SLUG = `/${SITTER_PROFILE_PREFIX}/[locationSlug]/testimonials`;

export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';

export const PAGE_LAYOUT_CONFIG: PageLayoutConfig = {
  [BOOKINGS_BETA_PAGE_SLUG]: { header: [MOBILE, DESKTOP], footer: [] },
  [BOOKING_BETA_PAGE_SLUG]: { header: [MOBILE, DESKTOP], footer: [] },
  [BOOKINGS_BETA_DETAIL_PAGE_SLUG]: { header: [MOBILE, DESKTOP], footer: [] },
  [HOME_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [HOW_IT_WORKS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [SEARCH_RESULTS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [PET_PROFILE_VIEW_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [NOT_FOUND_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [SERVICES_AND_RATES_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [SERVICE_SETTINGS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [SHARED_SERVICE_SETTINGS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [SERVICE_LANDING_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [SITTER_PROFILE_PAGE_SLUG]: {
    header: [DESKTOP],
    footer: [DESKTOP],
  },
  [ACCOUNT_SETTINGS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [ACCOUNT_BETA_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [PERSONAL_DETAILS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [PROFILE_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [PROFILE_ABOUT_PAGE_URL]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [PHOTO_GALLERY_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [PHOTOS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [REFERRAL_LANDING_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [FAVOURITES_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [MESSAGES_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [CHAT_BETA_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [MAD_PAWS_CREDITS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [PAYMENT_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [CALENDAR_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [REDEEM_BALANCE_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [TESTIMONIALS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [PASSWORD_RECOVERY_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [PASSWORD_RESET_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [VERIFICATION_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [NOTIFICATION_SETTINGS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [HOUSEHOLD_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [BOOKING_ENQUIRY_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [CONTACT_MORE_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [BOOKING_CONFIRMATION_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [PETS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [SIGN_IN_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [SITTER_REGISTRATION_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [MOBILE, DESKTOP],
  },
  [BOOKING_PAYMENT_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [BOOKING_RWB_REVIEW_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [PEAK_BOOKING_AVAILABILITY_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
  [WRITE_TESTIMONIALS_PAGE_SLUG]: {
    header: [MOBILE, DESKTOP],
    footer: [],
  },
};
